// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from "iview"
import Plugin from "./tools"
import Viewer from 'v-viewer'
import axios from "axios";
//获取url的值
import utils from './utils'
Vue.prototype.$utils=utils


import '@/theme/index.less';
import 'viewerjs/dist/viewer.css'

Vue.config.productionTip = false
Vue.prototype.$axios = axios;

Vue.use(iView)
Vue.use(Plugin)
Vue.use(Viewer)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js